import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.tipReason}} {{d-icon \"circle-xmark\"}}",{ moduleName: "discourse/components/popup-input-tip.hbs" })